<template>
  <div
    v-if="backInStockPopupIsShowing"
    class="popup-wrapper"
    data-close
    @click="hideBackInStockPopup($event)"
  >
    <div class="popup">
      <button
        class="popup__close close-btn xs font-semibold flex items-center"
        data-close
        @click="hideBackInStockPopup($event)"
      >
        Close
        <CloseIcon />
      </button>

      <h2 class="popup__title h5 text-center">
        <template v-if="formSubmitted">
          {{ title }}
        </template>
        <template v-else>
          <template v-if="isComingSoon">
            Email me when {{ productData.title.split(' / ')[0] }} is in stock
          </template>
          <template v-else>
            Email me when {{ productData.title.split(' / ')[0] }} is back in stock
          </template>
        </template>
      </h2>
      <p class="popup__text text-center">
        {{ text }}
      </p>
      <div
        v-if="!success"
        class="popup__form sm:flex"
      >
        <div class="field">
          <input
            v-model="email"
            type="email"
            placeholder="Email address"
            class="popup__email-input"
          >
        </div>
        <input
          type="submit"
          class="btn btn--black"
          :class="{ 'disabled': disableSubmitBtn }"
          :value="loading ? '...' : 'Notify me'"
          :disabled="disableSubmitBtn"
          @click="submit"
        >
      </div>
      <button
        v-if="success"
        class="cart-slideout__continue text-center mx-auto font-medium block sm underline"
        data-close
        @click="hideBackInStockPopup($event)"
      >
        {{ strings.continue }}
      </button>
    </div>
  </div>
</template>

<script>
import { useProductStore } from '../../pinia/ProductStore'
import { mapState, mapActions } from 'pinia'
import CloseIcon from '../../icons/close-icon'

export default {
  components: { CloseIcon },
  props: {
    quickViewSelectedVariant: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      strings: { ...window.theme.cart.strings },
      klaviyo: { ...window.theme.klaviyo },
      loading: false,
      success: false,
      formSubmitted: false,
      email: window.theme.customer.email,
      title: 'All set!'
    }
  },
  computed: {
    ...mapState(useProductStore, [
      'product',
      'selectedVariant',
      'backInStockPopupIsShowing',
      'isCombinedListingsProduct'
    ]),

    text () {
      if (this.formSubmitted) {
        return `You will receive a notification when ${this.capitalizeAllWords(this.productData.title.split(' / ')[0].toLowerCase())} comes back in stock.`
      } else {
        if (this.isComingSoon) {
          return 'Drop your email below to receive a notification when this item arrives.'
        } else {
          return 'Drop your email below to receive a notification when this item comes back in stock.'
        }
      }
    },

    isComingSoon () {
      return this.productData.tags.includes('coming-soon') && !this.productData.available
    },

    variant () {
      return this.quickViewSelectedVariant || this.selectedVariant
    },

    productData () {
      const data = this.quickViewSelectedVariant || this.isCombinedListingsProduct ? this.variant : this.product
      if (this.isCombinedListingsProduct) {
        return {
          ...data,
          tags: this.product.tags
        }
      }
      return data
    },

    emailIsValid () {
      const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      return this.email && this.email.match(mailformat)
    },
    disableSubmitBtn () {
      return this.loading || !this.emailIsValid
    }
  },
  methods: {
    ...mapActions(useProductStore, ['hideBackInStockPopup']),

    capitalizeAllWords (string) {
      return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
    
    submit () {
      this.loading = true

      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.klaviyo.publicApiKey}`

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.email
                }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${this.variant.id}`
              }
            }
          }
        }
      }

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: "2024-06-15"
        },
        body: JSON.stringify(payload)
      })
      .then(response => {
        if (response.ok) {
          this.formSubmitted = true
          this.success = true
          this.title = 'All set!'
        } else {
          return response.json().then(err => { throw err })
        }
      })
      .catch(error => {
        console.error('error', error.errors ? error.errors[0].detail : error)
        this.formSubmitted = true
        this.title = 'Oops'
        this.text = 'Your email is invalid or the request failed!\nPlease try again.'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>